import { useMutation } from '@tanstack/react-query';

import { BatchCustomsStateNotificationType } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchId: string;
  filterType: BatchCustomsStateNotificationType;
}

export const useRetrieveDeclarationByNotification = () =>
  useMutation({
    mutationFn: async ({ batchId, filterType }: HookProps): Promise<string | undefined> => {
      try {
        const result = await apiClient.declarations.retrieveDeclarationByNotification.query({ query: { batchId, filterType } });
        if (result.status !== 200) throw result.body;

        const declarationId = result.body.data.declarationId;
        return declarationId ? `/declarations/${declarationId}/customs-state?source=batches&all-statuses=false` : undefined;
      } catch (error) {
        showErrorToast(error, 'Failed getting the first declaration');
        return undefined;
      }
    },
  });
